module.exports = __webpack_public_path__ + "a56119368c769c9d8a2520f446e744da.MP3";